import 'ol/ol.css';
import {fromLonLat} from 'ol/proj';
import {Map, View} from 'ol';
import {Vector as VectorLayer, Tile as TileLayer} from 'ol/layer';
//import {Vector as VectorSource} from 'ol/source';
import {Cluster,Vector as VectorSource} from 'ol/source';
//import {Vector as VectorLayer, Tile as TileLayer} from 'ol/layer/Tile';
import XYZSource from 'ol/source/XYZ';

 import {Icon, Circle as CircleStyle, Fill, Stroke, Style, Text} from 'ol/style.js';


import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Renderer from 'ol/renderer/webgl/PointsLayer';
import {clamp} from 'ol/math';


//vector of ships start
const source = new VectorSource();

const client = new XMLHttpRequest();

if (screen.width <= 800) {
client.open('GET', 'xml/21_03_26odd2.csv');
//console.log('odd');
}
else{
client.open('GET', 'xml/21_03_26odd.csv');
//console.log('even');
};


client.onload = function() {
  const csv = client.responseText;
  const features = [];

  let prevIndex = csv.indexOf('\n') + 1; // scan past the header line

  let curIndex;
  while ((curIndex = csv.indexOf('\n', prevIndex)) != -1) {
    const line = csv.substr(prevIndex, curIndex - prevIndex).split(',');
    prevIndex = curIndex + 1;

    const coords = fromLonLat([parseFloat(line[1]), parseFloat(line[0])]);
    if (isNaN(coords[0]) || isNaN(coords[1])) {
      // guard against bad data
      continue;
    }

    features.push(new Feature({
      length: parseFloat(line[5]) || 0,
      type: parseInt(line[2]) || 0,
      heading: parseInt(line[3]) || 0,
      speed: parseInt(line[4]) || 0,
      geometry: new Point(coords),
      anchor: [ 0, 0 ]
    }));
  }
  source.addFeatures(features);
};
client.send();




/////extra maps
const mt = new XYZSource({
  url: 'https://tiles3.marinetraffic.com/densitymaps2017/density_tiles2017/{z}/{x}/{y}.png'
            });

/* 
const opensea = new XYZSource({
     url: 'http://t1.openseamap.org/seamark/{z}/{x}/{y}.png',
  });
 */

/// Esri ocean depths
/* 
const ocean2 = new XYZSource({
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                  'Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}'
            });
            
 */
            
//////iconcluster            

var styleCache = {};
const getIconStyle = function(feature) {

var cfeatures = feature.get('features');

  if(cfeatures.length > 1) {
     //cluster
    var heading =cfeatures[1].get('heading');
	var angle = (heading * Math.PI) / 180;
	var speed =cfeatures[1].get('speed');
	var type =cfeatures[1].get('type');
   // console.log(cfeatures[0].get('heading'));
 var size = feature.get('features').length;
          var style = styleCache[size];
          if (!style) {
          if (speed==0){
if (type==0){// Manned vts
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else if (type==1){// Navigations Aids
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [210, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==2){// fishing?
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==3){// Tug, Pilot, etc.
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [150, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==4){// High Speed Craft
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [60, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==6){// Passenger Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [0, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==7){// Cargo Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [90, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==8){// Tanker
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [30, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==9){// Yacht & Other
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  
{
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}        
}
else //speed

{
if (type==0){// Manned vts
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else if (type==1){// Navigations Aids
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [210, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==2){// fishing?
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==3){// Tug, Pilot, etc.
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [150, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==4){// High Speed Craft
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [60, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==6){// Passenger Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [0, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==7){// Cargo Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [90, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==8){// Tanker
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [30, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==9){// Yacht & Other
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  
{
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}        

}
            styleCache[size] = style;
          }
          return style;
  } 
  else 
  if(cfeatures.length == 1){
     //no clusters
    var heading =cfeatures[0].get('heading');
	var angle = (heading * Math.PI) / 180;
	var speed =cfeatures[0].get('speed');
	var type =cfeatures[0].get('type');
    //console.log(cfeatures[0].get('type'));

if (speed==0){
if (type==0){// Manned vts
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else if  (type==1){// Navigations Aids
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [210, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
 else  if (type==2){// fishing?
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==3){// Tug, Pilot, etc.
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [150, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==4){// High Speed Craft
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [60, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==6){// Passenger Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [0, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==7){// Cargo Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [90, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==8){// Tanker
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [30, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==9){// Yacht & Other
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  
{
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}        
 return style;
}

//speed
else{
if (type==0){// Manned vts
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else if(type==1){// Navigations Aids
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [210, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==5){// fishing?
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==3){// Tug, Pilot, etc.
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [150, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==4){// High Speed Craft
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [60, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==6){// Passenger Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [0, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==7){// Cargo Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [90, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==8){// Tanker
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [30, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==9){// Yacht & Other
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  
{
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}        
 return style;

}
}
}



var clusterSource = new Cluster({
        distance: 10,
        source: source
      });
      
     var clusters = new VectorLayer({
        source: clusterSource
        ,
		style:getIconStyle
      });      
      
var osmt = new TileLayer({
  source: mt,
  opacity: 1.0,
  visible: false
});
      
var map = new Map({
  target: 'map-container',
  layers: [
/* 
  new TileLayer({
      source: ocean2,
      opacity: 0.1
    }),
 */
/* 
    new TileLayer({
      source: opensea,
      opacity: 1.0
    })
,
 */
osmt
,

clusters

  ],
  view: new View({
    center: [0, 30]
    ,
    zoom: 0
  })
});

map.on('pointermove', function(evt) {

       osmt.setVisible(true);
       setTimeout(function () {
        osmt.setVisible(false);
    }, 3000);
});

map.on('pointerdrag', function(evt) {
   if ( evt.dragging) {
       osmt.setVisible(true);
       setTimeout(function () {
        osmt.setVisible(false);
    }, 3000);
        
  }
});

map.on('click', function(evt) {
this.getTargetElement().style.cursor = 'crosshair';
show();
});

